import MainLayout from "@/components/Layout/MainLayout"
import NewPageMyReservation from "@/views/NewPageMyReservation.vue"
import NewPageSearchReservation from "@/views/NewPageSearchReservation.vue"
import PageMyReservationForm from "@/views/PageMyReservationForm.vue"
import PageMyReservationInfo from "@/views/PageMyReservationInfo.vue"

export default [
  {
    path: "/MyReservation",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "NewPageMyReservation",
        component: NewPageMyReservation,
      },
    ],
  },
  {
    path: "/MyReservationForm",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "PageMyReservationForm",
        component: PageMyReservationForm,
        props: true,
      },
    ],
  },
  {
    path: "/MyReservationInfo",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "PageMyReservationInfo",
        component: PageMyReservationInfo,
        props: true,
      },
    ],
  },
  {
    path: "/SearchReservation",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "NewPageSearchReservation",
        component: NewPageSearchReservation,
        props: true,
      },
    ],
  },
]
